
const Dashboard = () => {
    return (
      <div>
        <h2>Users Page</h2>
        <p>This is where you can manage users.</p>
      </div>
    );
  };
  
  export default Dashboard;